import { render, staticRenderFns } from "./Abandon.vue?vue&type=template&id=289087dc&scoped=true"
import script from "./Abandon.vue?vue&type=script&lang=ts"
export * from "./Abandon.vue?vue&type=script&lang=ts"
import style0 from "./Abandon.vue?vue&type=style&index=0&id=289087dc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289087dc",
  null
  
)

export default component.exports